import styled from "styled-components";
import { colors } from "../colors";

export const TypeWriterWrapper = styled.div`
  font-size: 1.5rem;
  color: ${colors.gray};
`;
